import React, { useState, useEffect, useRef } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import scoringService from '../../services/ScoringService';

const TeamPitchPositionModal = (props) => {

    const { show, onHide, homeTeam, awayTeam, firstHalfTeam, secondHalfTeam, fixtureRoomId } = props;

    const [loading, setLoading] = useState(true);

    const [firstHalfLeftTeam, setFirstHalfLeftTeam] = useState(null);
    const [secondHalfLeftTeam, setSecondHalfLeftTeam] = useState(null);

    const dropdownFirstHalfRef = useRef(null);
    const dropdownSecondHalfRef = useRef(null);

    useEffect(() => {
        if (loading && homeTeam !== null && awayTeam !== null) {
            setLoading(false);

            if (firstHalfTeam == null && secondHalfTeam == null) {
                setFirstHalfLeftTeam('Home');
                setSecondHalfLeftTeam('Away');
            } else {
                let initialFirstHalfLeftTeam = (firstHalfTeam == homeTeam.id ? "Home" : "Away");
                let initialSecondHalfLeftTeam = (secondHalfTeam == homeTeam.id ? "Home" : "Away");
                setFirstHalfLeftTeam(initialFirstHalfLeftTeam);
                setSecondHalfLeftTeam(initialSecondHalfLeftTeam);
            }
        }
    }, []);

    return <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title>
                <h3>
                    Set Teams Pitch Positions
                </h3>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1">Team at left during first half:</span>
                        <Form.Control as="select"
                            size="sm"
                            ref={dropdownFirstHalfRef}
                            value={firstHalfLeftTeam} onChange={(event, value) => { setFirstHalfLeftTeam(dropdownFirstHalfRef.current.value); setSecondHalfLeftTeam(firstHalfLeftTeam) }}
                            className="ml-1"
                            style={{ width: '175px' }}
                        >
                            <option value="Home">Home</option>
                            <option value="Away">Away</option>
                        </Form.Control>
                    </div>
                </Col>
            </Row>
            <Row className="pt-2">
                <Col>
                    <div className="d-flex">
                        <span className="py-1">Team at left during second half:</span>
                        <Form.Control as="select"
                            size="sm"
                            ref={dropdownSecondHalfRef}
                            value={secondHalfLeftTeam} onChange={(event, value) => { setSecondHalfLeftTeam(dropdownSecondHalfRef.current.value); setFirstHalfLeftTeam(secondHalfLeftTeam) }}
                            className="ml-1"
                            style={{ width: '175px' }}
                        >
                            <option value="Home">Home</option>
                            <option value="Away">Away</option>
                        </Form.Control>
                    </div>
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={(e) => {

                let firstHalfTeam = firstHalfLeftTeam === "Home" ? homeTeam.id : awayTeam.id;
                let secondHalfTeam = secondHalfLeftTeam === "Home" ? homeTeam.id : awayTeam.id;

                scoringService.updateTeamPitchOrigins(fixtureRoomId, firstHalfTeam, secondHalfTeam).then((res) => {
                    onHide(e);
                });

            }}>Save</Button>
            <Button variant="btn-danger" onClick={onHide}>Cancel</Button>
        </Modal.Footer>
    </Modal>;
}

export default TeamPitchPositionModal;